import React from 'react';
import PropTypes from 'prop-types';
import { localsMessages } from '../utility/getTemplateData';
import { getCountryInfo } from '../utility/localizer';
import { Checkbox } from '@paypalcorp/pp-react-checkbox';
import getContent from 'pp-react-l10n';

const messages = localsMessages('common/guestTerms');

class GuestTerms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: !!this.props.isChecked,
    };
  }

  onChange = (event) => {
    const isChecked = event.target.checked;
    this.setState({ isChecked });
    this.props.handleRequired(isChecked);
  };

  render() {
    const countryInfo = getCountryInfo(this.props.country);
    const termsContent = getContent('locals')('common/guestTerms')(
      'terms',
      null,
      { useHTML: true }
    );

    if (this.props.mandatory) {
      return null;
    }

    return (
      <React.Fragment>
        {countryInfo.showGuestTermsWithoutCheckBox && !this.props.isSignUp && (
          <div className="guest-terms ppvx_row ppvx_justify-content-center ppvx_align-items-center mt-16 mb-16">
            <div className="ppvx_col-12 legal-text">{GuestTerms}</div>
          </div>
        )}
        {countryInfo.showGuestTermsCheckBox && !this.props.isSignUp && (
          <div className="guest-terms ppvx_row ppvx_justify-content-center ppvx_align-items-center mt-16 mb-16">
            <div className="ppvx_col-12">
              <Checkbox
                label={termsContent}
                name="termsCheckbox"
                id="termsCheckbox"
                onChange={this.onChange}
                checked={this.state.isChecked}
                error={this.props.hasError}
                errorText={messages.pleaseConfirm}
              />
            </div>
          </div>
        )}

        {countryInfo.showGuestTermsText && (
          <div className="guest-terms small ppvx_row ppvx_justify-content-center ppvx_align-items-center mt-16 mb-16">
            <div className="ppvx_col-12 legal-text text-center">
              {termsContent}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

GuestTerms.propTypes = {
  handleRequired: PropTypes.func,
  label: PropTypes.string,
  country: PropTypes.string,
  isSignUp: PropTypes.bool,
  mandatory: PropTypes.bool,
  isChecked: PropTypes.bool,
  hasError: PropTypes.bool,
};

export default GuestTerms;
